export { default as ProductCardSkeleton } from "./ProductCardSkeleton";
